import Color from 'color'

export const isDarkColor = (color: string): boolean => {
  return Color(color).darken(0.2).isDark()
}
